export const commonFlags = {
  // environment: Flags.string({
  //   char: "e",
  //   default: defaultTargetEnv,
  //   description: "Target environment (demo, development, local, production, staging)",
  //   options: targetEnvs,
  // }),
}
